module.exports = __webpack_public_path__ + "img/link-link.66cbca6e.svg";